import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import therapistService from '../../../services/apiServices/therapist-scheduling/therapistService';
import { TherapistAction } from '../../actions/constant';
import nProgress from 'nprogress';

const {
  PRE_THERAPIST_PROFILE_REQUEST,
  PRE_THERAPIST_PROFILE_SUCCESS,
  PRE_THERAPIST_PROFILE_FAILURE,
} = TherapistAction;

function* preGetTherapistProfile(action: any): SagaReturnType<any> {
  try {
    nProgress.start();
    const response = yield call(therapistService.PreGetTherapistProfile, action.payload);
    if (response?.status === 200) {
      nProgress.done();
      localStorage.setItem('facility_timezone', response.data?.data?.timeZone);
      yield put({ type: PRE_THERAPIST_PROFILE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    nProgress.done();
    yield put({ type: PRE_THERAPIST_PROFILE_FAILURE, payload: error });
  }
}

function* preGetTherapistProfileSaga() {
  yield takeEvery(PRE_THERAPIST_PROFILE_REQUEST, preGetTherapistProfile);
}

export default preGetTherapistProfileSaga;
